import useOrientation from "@jnctn/hooks/useOrientation";

export default function useIsPortrait() {
  return useOrientation() === "portrait";
}
